// Helpers puros de construcción de la tabla de indicadores (IndicatorTable.tsx).
// Extraídos para poder testear el formato numérico que se muestra al usuario
// sin renderizar la antd Table. `import type` evita arrastrar Chart (highcharts).
import numeral from 'numeral'
import type { SelectedSeries } from '../components/Chart'

export type SortDirection = 'ascend' | 'descend'
export type IndicatorRow = { [key: string]: string | number | null }
export type IndicatorColumn = {
  title: string
  dataIndex: string
  sortDirections: SortDirection[]
  sorter: (a: any, b: any) => number
}

// Formatea el valor numérico a '0,0.00' (miles con coma, 2 decimales).
// Un valor falsy (0, null) se devuelve tal cual (passthrough).
export const formatCell = (value: number | null): string | number | null =>
  value ? numeral(value).format('0,0.00') : value

export const buildTableData = (series: SelectedSeries[]): IndicatorRow[] =>
  series.map(s => ({
    nombre: s.name,
    ...s.values.reduce((prev, current) => {
      return {
        ...prev,
        [String(current.year)]: formatCell(current.value as number | null),
      }
    }, {} as IndicatorRow),
  }))

export const buildTableColumns = (series: SelectedSeries[]): IndicatorColumn[] => {
  const nameColumn: IndicatorColumn = {
    title: 'Nombre',
    dataIndex: 'nombre',
    sortDirections: ['ascend', 'descend'],
    sorter: (a, b) => a.nombre.localeCompare(b.nombre),
  }

  const yearColumns = series[0].values.map(v => ({
    title: String(v.year),
    dataIndex: String(v.year),
    sortDirections: ['ascend', 'descend'] as SortDirection[],
    // número (no string) para que 10 > 9 en orden ascendente
    sorter: (a: any, b: any) => Number(a[v.year]) - Number(b[v.year]),
  }))

  return [nameColumn, ...yearColumns]
}